import * as Sentry from "@sentry/react";
import { Alert, Button } from "react-bootstrap";
import PropTypes from "prop-types";

const ErrorFallback = ({ error, resetErrorBoundary }) => {

	Sentry.captureException(`From ErrorBoundary Fallback: ${error}`);

	return (
		<Alert role="alert" variant="danger">
			<h4>Sorry, something went wrong!</h4>
			<p>{error.message}</p>
			<Button onClick={resetErrorBoundary}>
				Please try again!
			</Button>
		</Alert>
	);

};

ErrorFallback.propTypes = {
	error: PropTypes.shape({
		message: PropTypes.string
	}).isRequired,
	resetErrorBoundary: PropTypes.func.isRequired
};

export default ErrorFallback;
